import React, { useState } from "react";
import { Button, Grid, TextField, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import InputAdornment from "@material-ui/core/InputAdornment";
import { connect } from "react-redux";
import InputMask from "react-input-mask";
import { actions } from "../redux/actions/alert";
import styles from "../styles/global-styles";
import { AuthService } from "../services/auth.service";
import { ExpenseService } from "../services/expense.service";

const useStyles = makeStyles((theme) => ({
  title: styles.title,
  rightButton: styles.buttonRightHeader,
  header: styles.header,
  subtitle: styles.subtitle,
}));

const ContainerExpensesBySite = ({ addAlert, detailAlert }) => {
  const { siteId } = AuthService.currentUserValue;
  const classes = useStyles();
  const [spendObject, setSpendObject] = useState({ siteId });

  const handleInputText = ({ target: { value, name } }) =>
    setSpendObject({ ...spendObject, [name]: value });

  const handleSaveExpense = async () => {
    try {
      const { data } = await ExpenseService.postExpense(spendObject);
      if (data) {
        addAlert({ showAlert: true });
        detailAlert({
          severity: "success",
          message: "Gasto guardado exitosamente",
        });
        const copyObject = { ...spendObject };
        delete copyObject.amount;
        delete copyObject.concept;
        setSpendObject(copyObject);
      }
    } catch (error) {
      console.log("error", error);
      addAlert({ showAlert: true });
      detailAlert({
        severity: "error",
        message: error.msgs,
      });
    }
  };

  const validateInputs = () => {
    let result = true;
    const valuesArray = Object.values(spendObject);
    if (valuesArray.length && valuesArray.length === 3) {
      const inputValids = valuesArray.some((item) => item === "");
      result = inputValids;
    }
    return result;
  };

  return (
    <>
      <Typography variant="h4" component="h4" className={classes.title}>
        Gastos
      </Typography>

      <Typography className={classes.header}>
        Ingresar los datos requeridos
      </Typography>

      <Grid
        container
        direction="row"
        justify="space-evenly"
        style={{ marginTop: 70 }}
        alignItems="flex-start"
      >
        <Grid item>
          <TextField
            name="concept"
            placeholder="Concepto"
            value={spendObject.concept || ""}
            variant="outlined"
            onChange={(e) => handleInputText(e)}
            multiline
          />
        </Grid>
        <Grid item>
          <InputMask
            mask="99999"
            maskChar=""
            value={spendObject.amount || ""}
            onChange={(e) => handleInputText(e)}
          >
            {() => (
              <TextField
                name="amount"
                placeholder="cantidad"
                variant="outlined"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">$</InputAdornment>
                  ),
                }}
              />
            )}
          </InputMask>
        </Grid>
        <Grid item>
          <Button
            variant="contained"
            color="primary"
            disabled={validateInputs()}
            className={classes.rightButton}
            type="submit"
            onClick={() => handleSaveExpense()}
          >
            Guardar
          </Button>
        </Grid>
      </Grid>
    </>
  );
};

const dispatch = {
  detailAlert: actions.detailAlert,
  addAlert: actions.addAlert,
};

export default connect(undefined, dispatch)(ContainerExpensesBySite);
